import moment from 'moment';

export const changeUnitDigit = (num: number): string => {
  return num < 10 ? `0${num}` : `${num}`;
};

export const isBeforeTime = (time: string): boolean => {
  return Number(moment().format('HH')) >= Number(moment(time).format('HH'));
};


export function changeDateFormat(time: string | Date, format: string): string {
  if (typeof time === 'string' && time === '') {
    return moment().format(format);
  }
  return moment(time).format(format);
}

export function getToday(separator?: string): string {
  return getStrDate(new Date(), separator);
}

export function getBeforeDate(firstDay?: number): string {
  let beforeDay = new Date().getDate() - 1;
  if (firstDay !== undefined && beforeDay < firstDay) {
    beforeDay = firstDay;
  }
  let beforeDate = new Date().setDate(beforeDay);
  return getStrDate(new Date(beforeDate));
}

export function firstDayOfMonth(): string {
  let firstDate = new Date().setDate(1);
  return getStrDate(new Date(firstDate));
}

export function getFirstAndEndDay(year: number, month: number): {startYmd: string; endYmd: string} {
  const startYmd = getStrDate(new Date(year, month - 1, 1));
  const endYmd = getStrDate(new Date(year, month, 0));
  return {startYmd, endYmd};
}

export function getStrDate(date: Date, separator?: string): string {
  if (date.constructor !== Date) {
    date = new Date(date.toString().replace(/-/g, '/'));
  }
  if (date.constructor !== Date) {
    return '';
  }

  let month: string | number = date.getMonth() + 1;
  let day: string | number = date.getDate();

  if (month < 10) {
    month = '0' + month;
  }
  if (day < 10) {
    day = '0' + day;
  }

  if (separator === null || separator === undefined) {
    separator = '-';
  }
  const reDate = date.getFullYear() + separator + month + separator + day;

  return reDate;
}
export function getDownToday(): string {
  let date = new Date();

  let month: string | number = date.getMonth() + 1;
  if (month < 10) {
    month = '0' + month;
  }

  let day: string | number = date.getDate();
  if (day < 10) {
    day = '0' + day;
  }
  let hours: string | number = date.getHours();
  if (hours < 10) {
    hours = '0' + hours;
  }

  let minutes: string | number = date.getMinutes();
  if (minutes < 10) {
    minutes = '0' + minutes;
  }

  let seconds: string | number = date.getSeconds();
  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  const reDate = date.getFullYear().toString() + month + day + '_' + hours + minutes + seconds;

  return reDate;
}
export function getStrYMDHMSS(date: any, separator?: any): string {
  if (date.constructor !== Date) {
    date = new Date(date.replace(/-/g, '/'));
  }

  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();

  if (month < 10) {
    month = '0' + month;
  }
  if (day < 10) {
    day = '0' + day;
  }
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  if (separator === null || separator === undefined) {
    separator = '-';
  }
  const reDate = date.getFullYear() + separator + month + separator + day + ' ' + hours + ':' + minutes + ':' + seconds;

  return reDate;
}

export function addDay(date: Date | string, cnt: number, separator?: string): string {
  if (date.constructor !== Date) {
    date = new Date(date.toString().replace(/-/g, '/'));
  }
  if (date.constructor !== Date) {
    return '';
  }

  if (separator === null || separator === undefined) {
    separator = '-';
  }

  date.setDate(date.getDate() + cnt);

  let month = date.getMonth() + 1;
  let day = date.getDate();

  let strMonth = '';
  if (month < 10) {
    strMonth = '0' + month;
  } else {
    strMonth = month.toString();
  }
  let strDay = '';
  if (day < 10) {
    strDay = '0' + day;
  } else {
    strDay = day.toString();
  }
  const reDate = date.getFullYear() + separator + strMonth + separator + strDay;

  return reDate;
}

export function addMonth(date: Date | string, cnt: number, separator?: string): string {
  if (date.constructor !== Date) {
    date = new Date(date.toString().replace(/-/g, '/'));
  }
  if (date.constructor !== Date) {
    return '';
  }

  if (separator === null || separator === undefined) {
    separator = '-';
  }

  let newDate = new Date(date.getFullYear(), date.getMonth() + cnt, date.getDate());
  const newDateEndDay = new Date(date.getFullYear(), date.getMonth() + cnt + 1, 0);
  if (newDate.getMonth() !== newDateEndDay.getMonth()) {
    newDate = newDateEndDay;
  }
  let month = newDate.getMonth() + 1;
  let day = newDate.getDate();

  let strMonth = '';
  if (month < 10) {
    strMonth = '0' + month;
  } else {
    strMonth = month.toString();
  }
  let strDay = '';
  if (day < 10) {
    strDay = '0' + day;
  } else {
    strDay = day.toString();
  }

  return newDate.getFullYear() + separator + strMonth + separator + strDay;
}

export function getSelectYears(str: any): object[] {
  const year = new Date().getFullYear();
  const result: object[] = [];
  for (let i = 3; i >= 0; i--) {
    const tempObj = {value: year - i, display: `${year - i} ${str}`};
    result.push(tempObj);
  }
  return result;
}

export function getSelectMonths(str: any): object[] {
  const result: object[] = [];
  for (let i = 1; i <= 12; i++) {
    const tempObj = {value: i, display: `${i} ${str}`};
    result.push(tempObj);
  }
  return result;
}
/**
 * Mutates the original moment by adding time.
 * https://momentjs.com/docs/#/manipulating/add/
 * @author AZu
 * @param date string
 * @param addDays []
 * @param format string
 */
export function momentAdd(date: string | Date, addDays: any[], format: string): string {
  return moment(date)
    .add(...addDays)
    .format(format);
}

export function getBeginYear(baseYear: number): number {
  return new Date().getFullYear() - 5 >= baseYear ? new Date().getFullYear() - 5 : baseYear;
}

export function range(start: number, end: number): number[] {
  const size = end - start + 1;

  return Array.from({length: size}, (d, i) => i + start);
}

export function getYearList(beginYear: number, endWord?: string): {value: number; name: string}[] {
  const todayYear = new Date().getFullYear();

  return range(beginYear, todayYear).map(idx => {
    return {
      value: idx,
      name: `${idx}${endWord ? endWord : ''}`
    };
  });
}

export function getMonthList(endWord?: string): {value: number; name: string}[] {
  return range(1, 12).map(idx => {
    return {
      value: idx,
      name: `${idx}${endWord ? endWord : ''}`
    };
  });
}

export function isBetween(startYmd: string, endYmd: string): boolean {
  const startTime = new Date(startYmd).getTime();
  const endTime = new Date(endYmd).getTime();
  const today = new Date().getTime();
  return startTime - today <= 0 && endTime - today > 0;
}

export function isSameOrAfter(startYmd: string, asOfYmd = ''): boolean{
  startYmd = changeDateFormat(startYmd, 'YYYY-MM-DD');
  return moment(asOfYmd?? getToday()).isSameOrAfter(startYmd);
}

export const convertMinutesToMilliseconds = (minutes: number): number => minutes * 60 * 1000;
